// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CashAppScoreEntrypointViewEvent
 */
export var CashAppScoreEntrypointView = function (_a) {
    var state = _a.state, currentScore = _a.currentScore, changeSinceLastWeek = _a.changeSinceLastWeek;
    return ({
        name: "CashAppScore Entrypoint View",
        parameters: {
            cdf_entity: "CashAppScore",
            cdf_action: "Entrypoint",
            state: state !== undefined && state !== null ? state.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_score: currentScore !== undefined && currentScore !== null ? currentScore.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            change_since_last_week: changeSinceLastWeek !== undefined && changeSinceLastWeek !== null ? changeSinceLastWeek.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppScoreEntrypointTapEvent
 */
export var CashAppScoreEntrypointTap = function (_a) {
    var state = _a.state, currentScore = _a.currentScore, changeSinceLastWeek = _a.changeSinceLastWeek;
    return ({
        name: "CashAppScore Entrypoint Tap",
        parameters: {
            cdf_entity: "CashAppScore",
            cdf_action: "Entrypoint",
            state: state !== undefined && state !== null ? state.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_score: currentScore !== undefined && currentScore !== null ? currentScore.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            change_since_last_week: changeSinceLastWeek !== undefined && changeSinceLastWeek !== null ? changeSinceLastWeek.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppScoreNUXViewEvent
 */
export var CashAppScoreNUXView = function () { return ({
    name: "CashAppScore NUX View",
    parameters: {
        cdf_entity: "CashAppScore",
        cdf_action: "NUX",
    }
}); };
/**
 * @see CashAppScoreNUXTapLearnMoreEvent
 */
export var CashAppScoreNUXTapLearnMore = function () { return ({
    name: "CashAppScore NUX TapLearnMore",
    parameters: {
        cdf_entity: "CashAppScore",
        cdf_action: "NUX",
    }
}); };
/**
 * @see CashAppScoreNUXTapViewScoreEvent
 */
export var CashAppScoreNUXTapViewScore = function () { return ({
    name: "CashAppScore NUX TapViewScore",
    parameters: {
        cdf_entity: "CashAppScore",
        cdf_action: "NUX",
    }
}); };
/**
 * @see CashAppScoreHomeViewEvent
 */
export var CashAppScoreHomeView = function (_a) {
    var currentScore = _a.currentScore, changeSinceLastWeek = _a.changeSinceLastWeek;
    return ({
        name: "CashAppScore Home View",
        parameters: {
            cdf_entity: "CashAppScore",
            cdf_action: "Home",
            current_score: currentScore !== undefined && currentScore !== null ? currentScore.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            change_since_last_week: changeSinceLastWeek !== undefined && changeSinceLastWeek !== null ? changeSinceLastWeek.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppScoreFAQViewEvent
 */
export var CashAppScoreFAQView = function (_a) {
    var fromScreen = _a.fromScreen, currentScore = _a.currentScore, changeSinceLastWeek = _a.changeSinceLastWeek;
    return ({
        name: "CashAppScore FAQ View",
        parameters: {
            cdf_entity: "CashAppScore",
            cdf_action: "FAQ",
            from_screen: fromScreen !== undefined && fromScreen !== null ? fromScreen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_score: currentScore !== undefined && currentScore !== null ? currentScore.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            change_since_last_week: changeSinceLastWeek !== undefined && changeSinceLastWeek !== null ? changeSinceLastWeek.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppScoreRecommendationViewEvent
 */
export var CashAppScoreRecommendationView = function (_a) {
    var order = _a.order, actionTitle = _a.actionTitle;
    return ({
        name: "CashAppScore Recommendation View",
        parameters: {
            cdf_entity: "CashAppScore",
            cdf_action: "Recommendation",
            order: order !== undefined && order !== null ? order.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action_title: actionTitle !== undefined && actionTitle !== null ? actionTitle.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppScoreRecommendationTapEvent
 */
export var CashAppScoreRecommendationTap = function (_a) {
    var order = _a.order, actionTitle = _a.actionTitle;
    return ({
        name: "CashAppScore Recommendation Tap",
        parameters: {
            cdf_entity: "CashAppScore",
            cdf_action: "Recommendation",
            order: order !== undefined && order !== null ? order.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action_title: actionTitle !== undefined && actionTitle !== null ? actionTitle.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppScoreRecommendationActionButtonTapEvent
 */
export var CashAppScoreRecommendationActionButtonTap = function (_a) {
    var actionTitle = _a.actionTitle, buttonTitle = _a.buttonTitle;
    return ({
        name: "CashAppScore Recommendation ActionButtonTap",
        parameters: {
            cdf_entity: "CashAppScore",
            cdf_action: "Recommendation",
            action_title: actionTitle !== undefined && actionTitle !== null ? actionTitle.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            button_title: buttonTitle !== undefined && buttonTitle !== null ? buttonTitle.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppScoreRecommendationInfoTapEvent
 */
export var CashAppScoreRecommendationInfoTap = function () { return ({
    name: "CashAppScore Recommendation InfoTap",
    parameters: {
        cdf_entity: "CashAppScore",
        cdf_action: "Recommendation",
    }
}); };
/**
 * @see CashAppScoreMilestonesViewEvent
 */
export var CashAppScoreMilestonesView = function (_a) {
    var currentScore = _a.currentScore, currentBorrowAmountLimit = _a.currentBorrowAmountLimit, nextMilestoneThreshold = _a.nextMilestoneThreshold, nextMilestoneBorrowLimit = _a.nextMilestoneBorrowLimit;
    return ({
        name: "CashAppScore Milestones View",
        parameters: {
            cdf_entity: "CashAppScore",
            cdf_action: "Milestones",
            current_score: currentScore !== undefined && currentScore !== null ? currentScore.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_borrow_amount_limit: currentBorrowAmountLimit !== undefined && currentBorrowAmountLimit !== null ? currentBorrowAmountLimit.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            next_milestone_threshold: nextMilestoneThreshold !== undefined && nextMilestoneThreshold !== null ? nextMilestoneThreshold.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            next_milestone_borrow_limit: nextMilestoneBorrowLimit !== undefined && nextMilestoneBorrowLimit !== null ? nextMilestoneBorrowLimit.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppScoreMilestonesTapExpandEvent
 */
export var CashAppScoreMilestonesTapExpand = function () { return ({
    name: "CashAppScore Milestones TapExpand",
    parameters: {
        cdf_entity: "CashAppScore",
        cdf_action: "Milestones",
    }
}); };
/**
 * @see CashAppScoreScoreDetailsViewEvent
 */
export var CashAppScoreScoreDetailsView = function (_a) {
    var currentScore = _a.currentScore, changeSinceLastWeek = _a.changeSinceLastWeek, featureImpact = _a.featureImpact;
    return ({
        name: "CashAppScore ScoreDetails View",
        parameters: {
            cdf_entity: "CashAppScore",
            cdf_action: "ScoreDetails",
            current_score: currentScore !== undefined && currentScore !== null ? currentScore.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            change_since_last_week: changeSinceLastWeek !== undefined && changeSinceLastWeek !== null ? changeSinceLastWeek.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            feature_impact: featureImpact !== undefined && featureImpact !== null ? featureImpact.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppScoreErrorViewEvent
 */
export var CashAppScoreErrorView = function (_a) {
    var fromScreen = _a.fromScreen;
    return ({
        name: "CashAppScore Error View",
        parameters: {
            cdf_entity: "CashAppScore",
            cdf_action: "Error",
            from_screen: fromScreen !== undefined && fromScreen !== null ? fromScreen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
